import React from 'react';
import SetPasswordPage from './SetPasswordPage';

export default function AcceptInvitePage() {
  return (
    <SetPasswordPage
      title="Accept your invite"
      subtitle="Set a password to join your organization."
      cta="Join & set password"
    />
  );
}
